// extracted by mini-css-extract-plugin
module.exports =  {"root":"xwBBRoDefFXCgLhyV5rG"};